import { AsmIntegrationsViewId } from '../models/asm-integrations-view-id';
import { AsmIntegrationsType } from '../models/asm-integrations-type';
import { TypeService, ViewService } from '@sol/components';

export function provideAsmIntegrationsViews(viewService: ViewService, typeService: TypeService): void {
  typeService.addType(AsmIntegrationsType.integrationRow);
  viewService.addView(
    AsmIntegrationsType.integrationRow.array,
    'read',
    AsmIntegrationsViewId.linkedIntegration,
    () =>
      import('../components/view/asm-view-read-linked-integration/asm-view-read-linked-integration.component').then(
        m => m.AsmViewReadLinkedIntegrationComponent,
      ),
    true,
  );
}
